import { Link, useParams } from 'react-router-dom';
import { useLangTranslation } from '../utils/translation';
import './PolicyPage.css';

export default function PolicyPage({ namespace, documentKey }) {
  const { lang = 'en' } = useParams();
  const t = useLangTranslation(namespace);
  const read = key => t(documentKey ? `${documentKey}.${key}` : key);
  const sections = read('sections');
  const ko = lang === 'ko';
  return <article className="policy-document" lang={ko ? 'ko' : 'en'}>
    <div className="policy-heading">
      <p className="policy-eyebrow">EDGE / TRUST &amp; PLAY</p>
      <h1>{read('title')}</h1>
      <p className="policy-summary">{read('summary')}</p>
      <div className="policy-meta"><span>{read('status')}</span><span>{ko ? '게시·수정일' : 'Published / updated'} <time dateTime={read('updated')}>{read('updated')}</time></span></div>
    </div>
    {read('languageNotice') && <p className="policy-language" lang={lang}>{read('languageNotice')} <Link to={`/ko/${documentKey ? 'cookies' : namespace}`}>한국어</Link> · <Link to={`/en/${documentKey ? 'cookies' : namespace}`}>English</Link></p>}
    <div className="policy-reading-layout">
      <nav className="policy-toc" aria-label={ko ? '문서 목차' : 'On this page'}>
        <span>{ko ? '이 페이지에서' : 'ON THIS PAGE'}</span>
        {sections.map((section,index)=><a key={index} href={`#policy-${index+1}`}><small>{String(index+1).padStart(2,'0')}</small>{section.title}</a>)}
      </nav>
      <div className="policy-body">
        {sections.map((section,index)=><section id={`policy-${index+1}`} key={index}>
          <span className="policy-section-number">{String(index+1).padStart(2,'0')}</span>
          <h2>{section.title}</h2>
          {section.paragraphs?.map((paragraph,i)=><p key={i}>{paragraph}</p>)}
          {section.items && <ul>{section.items.map((item,i)=><li key={i}>{item}</li>)}</ul>}
          {section.links && <div className="policy-source-links">{section.links.map(link=><a key={link.href} href={link.href} target="_blank" rel="noreferrer">{link.label} ↗</a>)}</div>}
        </section>)}
      </div>
    </div>
  </article>;
}
